<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Template
  Reason: Read-only flatten display of person rows with dynamic TYPED external side-car
          columns (ext_<typeFieldId>) for a selected (ExternalPartyAssignment, XxPersonType)
          pair via the two-parameter bounded join (TM-1000001960).
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Party + type selectors -->
        <p-panel header="Externe Partei / Zuordnung + Personentyp">
            <div class="flex flex-wrap align-items-center gap-3">

                <div class="flex align-items-center gap-2">
                    <label for="xx-typed-assignment" class="font-medium">Externe Partei / Zuordnung</label>
                    <p-select
                            inputId="xx-typed-assignment"
                            [options]="assignments"
                            [(ngModel)]="selectedAssignment"
                            (onChange)="onSelectionChange()"
                            [showClear]="true"
                            placeholder="Zuordnung auswählen"
                            appendTo="body"
                            styleClass="w-20rem">
                        <ng-template let-assignment pTemplate="selectedItem">
                            @if (assignment) {
                                <span>{{ resolveAssignmentLabel(assignment) }}</span>
                            }
                        </ng-template>
                        <ng-template let-assignment pTemplate="item">
                            <span>{{ resolveAssignmentLabel(assignment) }}</span>
                        </ng-template>
                    </p-select>
                </div>

                <div class="flex align-items-center gap-2">
                    <label for="xx-typed-type" class="font-medium">Personentyp</label>
                    <p-select
                            inputId="xx-typed-type"
                            [options]="personTypes"
                            [(ngModel)]="selectedType"
                            (onChange)="onSelectionChange()"
                            [showClear]="true"
                            placeholder="Personentyp auswählen"
                            appendTo="body"
                            styleClass="w-20rem">
                        <ng-template let-type pTemplate="selectedItem">
                            @if (type) {
                                <span>{{ resolveTypeLabel(type) }}</span>
                            }
                        </ng-template>
                        <ng-template let-type pTemplate="item">
                            <span>{{ resolveTypeLabel(type) }}</span>
                        </ng-template>
                    </p-select>
                </div>

            </div>
        </p-panel>

        <!-- Error state -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Loading state -->
        @if (loading) {
            <div class="flex justify-content-center align-items-center p-5 gap-2">
                <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
                <span class="text-color-secondary">Daten werden geladen…</span>
            </div>
        }

        <!-- Result section -->
        @if (!loading && selectedAssignment && selectedType && !errorMessage) {
            <p-panel [header]="externalSectionTitle">

                @if (rows.length === 0) {
                    <p-message
                            severity="info"
                            text="Keine Personen mit typisierten externen Daten für diese Auswahl gefunden."
                            styleClass="w-full"></p-message>
                } @else {
                    <p-table [value]="rows" [scrollable]="true" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Vorname</th>
                                <th>Nachname</th>
                                @for (col of externalColumns; track col.key) {
                                    <th>{{ col.header }}</th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ displayValue(row, 'firstName') }}</td>
                                <td>{{ displayValue(row, 'lastName') }}</td>
                                @for (col of externalColumns; track col.key) {
                                    <td>{{ displayValue(row, col.key) }}</td>
                                }
                            </tr>
                        </ng-template>
                    </p-table>
                }
            </p-panel>
        }

        <!-- Initial empty / no-selection hint -->
        @if (!loading && (!selectedAssignment || !selectedType) && !errorMessage) {
            <p-message
                    severity="info"
                    text="Bitte oben eine externe Partei / Zuordnung und einen Personentyp auswählen, um die typisierten externen Daten anzuzeigen."
                    styleClass="w-full"></p-message>
        }
    </div>
}
